export enum PaymentMethod {
  Other = 'Other',
  Receivable = 'Receivable'
}
